module.exports = __webpack_public_path__ + "static/media/intro.60202e76.jpg";